import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import { s } from '@functions/seo.ts';

import I from '../types.ts';

const renderHead: I['renderHead'] = function () {
    const { designMode, handlerMenu } = this.props;

    return (
        <div className="publicMobileMenu__head _row">
            {!s() && (
                <img
                    src={require(
                        `@img/crm/${designMode === 'newYear' ? 'newYear/logo.svg' : 'logo.svg'}`,
                    )}
                    alt=""
                    className="publicMobileMenu__logo"
                />
            )}
            <i
                className="publicMobileMenu__close"
                onClick={() => {
                    handlerMenu(false);
                }}
            >
                <Icon name="public-close" />
            </i>
        </div>
    );
};

export default renderHead;
